import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const UrgentDeliveryConfirmationModal = ({
  visible = false,
  handleModalClose = () => {},
  handleUpdateSelectedDelivery = () => {},
}) => {
  return (
    <Modal
      isOpen={visible}
      toggle={handleModalClose}
      style={{ maxWidth: "650px", marginTop: "100px" }}
    >
      <ModalHeader>Incomplete Urgent Delivery Request</ModalHeader>
      <ModalBody>
        <p>
          {`You have not completed your delivery request - Your request
          will not be processed. Do you wish to start a new request?`}
        </p>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-primary"
          onClick={handleUpdateSelectedDelivery}
        >
          Yes
        </button>
        <button className="btn" onClick={handleModalClose}>
          No
        </button>
      </ModalFooter>
    </Modal>
  );
};
export default UrgentDeliveryConfirmationModal;
